// extracted by mini-css-extract-plugin
export default {"root":"RepresentTermsOfService_root__b-AQw","list":"RepresentTermsOfService_list__2OIEY"};